import React from 'react';

export default function ({ children }) {
    return (
        <tr
            role="row"
            data-p-highlight="true"
            data-p-highlight-contextmenu="false"
            data-pc-section="bodyrow"
        >
          {children}
        </tr>
    );
}
